export function createMohostConfig() {
	return {
	"validateFormAnswers": true,
	"title": "MOHOST",
	"instructions": "Record a professional judgment for each item, using observations, interviews, proxy reports and records as appropriate. If genuinely undecided between two ratings, choose the lower rating. Explain any unrated item in its comment.",
	"ordinalProfile": {
		"sections": [
			{
				"id": "section1",
				"title": "Motivation for Occupation",
				"items": [
					{
						"id": "appraisalofability",
						"title": "Appraisal of Ability",
						"question": "Appraisal of Ability",
						"guidance": "Understanding of current strengths and limitations; accurate belief in skill and competence; awareness of capacity\nF — Accurately assesses own capacity, recognizes strengths, aware of limitations\nA — Reasonable tendency to over/under estimate own abilities, recognizes some limitations\nI — Difficulty understanding strengths and limitations without support\nR — Does not reflect on skills, fails to realistically estimate own abilities"
					},
					{
						"id": "expectationofsuccess",
						"title": "Expectation of Success",
						"question": "Expectation of Success",
						"guidance": "Optimism and hope; self-efficacy, sense of control and identity\nF — Anticipates success and seeks challenges, optimistic about overcoming obstacles\nA — Has some hope for success, adequate self-belief but has some doubts, may need encouraging\nI — Requires support to sustain optimism about overcoming obstacles, poor self-efficacy\nR — Pessimistic, feels hopeless, gives up in the face of obstacles, lacks sense of control"
					},
					{
						"id": "interest",
						"title": "Interest",
						"question": "Interest",
						"guidance": "Expressed enjoyment; satisfaction; curiosity; participation\nF — Keen, curious, lively, tries new occupations, expresses pleasure, perseveres, appears content\nA — Has adequate interests that guide choices, has some opportunities to pursue interests\nI — Difficulty identifying interests, short-lived, ambivalent about choice of occupations\nR — Easily bored, unable to identify interests, apathetic, lacks curiosity even with support"
					},
					{
						"id": "choices",
						"title": "Choices",
						"question": "Choices",
						"guidance": "Commitment; readiness for change; value and meaning; preferences and goals\nF — Clear preferences & sense of what is important, motivated to work towards occupational goals\nA — Mostly able to make choices, may need encouragement to set and work towards goals\nI — Difficulties identifying what is important or setting and working towards goals, inconsistent\nR — Cannot set goals, impulsive, chaotic, goals are unattainable or based on anti-social values"
					}
				]
			},
			{
				"id": "section2",
				"title": "Pattern of Occupation",
				"items": [
					{
						"id": "routine",
						"title": "Routine",
						"question": "Routine",
						"guidance": "Balance; habits; structure; productivity\nF — Able to arrange a balanced, organized and productive routine of daily activities\nA — Generally able to maintain or follow and organized and productive daily schedule\nI — Difficulty organizing balanced, productive routines of daily activities without support\nR — Chaotic or empty routine, unable to support responsibilities and goals, erratic routine"
					},
					{
						"id": "adaptability",
						"title": "Adaptability",
						"question": "Adaptability",
						"guidance": "Anticipation, habitual response and tolerance of change\nF — Anticipates change, alters actions or routine to meet demand, (flexible/accommodating)\nA — Generally able to modify behavior, may need time to adjust, hesitant\nI — Difficulty adapting to change, reluctant, passive or habitually overreacts to change\nR — Rigid, unable to adapt routines or tolerate change"
					},
					{
						"id": "roles",
						"title": "Roles",
						"question": "Roles",
						"guidance": "Role identity and variety; belonging; involvement\nF — Identifies with a variety of roles, has a sense of identity/belonging that comes from roles\nA — Generally identifies with one or more roles and has some sense of belonging from these roles\nI — Limited identification of roles, role overload or conflict, poor sense of belonging\nR — Does not identify with any role, negligible role demands, no sense of belonging"
					},
					{
						"id": "responsibility",
						"title": "Responsibility",
						"question": "Responsibility",
						"guidance": "Role competence; meeting expectations and obligations\nF — Reliably completes activities and meets the expectations related to role obligations\nA — Copes with most responsibilities, meets most expectations, able to fulfil most role obligations\nI — Difficulty being able to fulfil expectations and meet role obligations without support\nR — Limited ability to meet demands of activities or obligations, unable to complete role activities"
					}
				]
			},
			{
				"id": "section3",
				"title": "Communication and Interaction Skills",
				"items": [
					{
						"id": "nonverbalskills",
						"title": "Non-verbal Skills",
						"question": "Non-verbal Skills",
						"guidance": "Eye contact; gestures; orientation; proximity\nF — Appropriate (possibly spontaneous) body language given culture and circumstances\nA — Generally able to display or control appropriate body language\nI — Difficulty controlling/displaying appropriate body language (delayed/limited/disinhibited)\nR — Unable to display appropriate body language (absent/incongruent/unsafe/aggressive)"
					},
					{
						"id": "conversation",
						"title": "Conversation",
						"question": "Conversation",
						"guidance": "Disclosing; initiating and sustaining conversation; content and language\nF — Appropriately initiates, discloses and sustains conversation (clear/direct/open)\nA — Generally able to use language or signing to effectively exchange information\nI — Difficulty initiating, disclosing or sustaining conversation (hesitant/abrupt/limited/irrelevant)\nR — Uncommunicative, disjointed, bizarre or inappropriate disclosure of information"
					},
					{
						"id": "vocalexpression",
						"title": "Vocal Expression",
						"question": "Vocal Expression",
						"guidance": "Intonation; articulation; volume; pace\nF — Assertive, articulate, uses appropriate tone, volume and pace\nA — Vocal expression is generally appropriate in tone, volume and pace\nI — Difficulty with expressing self (mumbling/pressured speech/monotone)\nR — Unable to express self (unclear/too quiet or loud/too fast or too passive)"
					},
					{
						"id": "relationships",
						"title": "Relationships",
						"question": "Relationships",
						"guidance": "Cooperation; collaboration; rapport; respect\nF — Sociable, supportive, aware of others, sustains engagement, friendly, relates well to others\nA — Generally able to relate to others and mostly demonstrates awareness of others’ needs\nI — Difficulty with cooperation or makes few positive relationships\nR — Unable to cooperate with others or make positive relationships"
					}
				]
			},
			{
				"id": "section4",
				"title": "Process Skills",
				"items": [
					{
						"id": "knowledge",
						"title": "Knowledge",
						"question": "Knowledge",
						"guidance": "Seeking and retaining information; knowing what to do and use\nF — Seeks and retains relevant information, know how to use tools appropriately\nA — Generally able to seek and retain information and know how to use tools\nI — Difficulty knowing how to use tools, difficulty in asking for or retaining information\nR — Unable to use knowledge/tools, does not retain information, asks repeatedly for same info"
					},
					{
						"id": "timing",
						"title": "Timing",
						"question": "Timing",
						"guidance": "Initiation; completion; sequencing; concentration\nF — Sustains concentration, starts, sequences and completes occupation at appropriate times\nA — Generally able to concentrate, start, sequence and complete occupations\nI — Fluctuating concentration or distractible, difficulty initiating, sequencing & completing\nR — Unable to concentrate, unable to initiate, sequence or complete occupations"
					},
					{
						"id": "organization",
						"title": "Organization",
						"question": "Organization",
						"guidance": "Arranging space and objects; preparation; gathering\nF — Efficiently searches for, gathers & restores tools/objects needed in occupation (neat)\nA — Generally able to search, gather and restore needed tools/objects\nI — Difficulty searching for, gathering and restoring tools/objects, appears disorganized/untidy\nR — Unable to search for, gather and restore tools and objects (chaotic, messy)"
					},
					{
						"id": "problemsolving",
						"title": "Problem-solving",
						"question": "Problem-solving",
						"guidance": "Judgment; adaptation; decision-making; responsiveness\nF — Shows good judgement, anticipates difficulties and generates workable solutions (rational)\nA — Generally able to make decisions based on difficulties that arise\nI — Difficulty anticipating and adapting to difficulties that arise, seeks reassurance\nR — Unable to anticipate and adapt to difficulties that arise and makes inappropriate decisions"
					}
				]
			},
			{
				"id": "section5",
				"title": "Motor Skills",
				"items": [
					{
						"id": "postureandmobility",
						"title": "Posture and Mobility",
						"question": "Posture and Mobility",
						"guidance": "Stability; alignment; positioning; balance; walking and transfers\nF — Stable, upright, independent, flexible, good range of movement (possibly agile)\nA — Generally able to maintain posture and mobility in occupation, independently or with aids\nI — Unsteady at times despite any aids, slow or manages with difficulty\nR — Extremely unstable, unable to reach and bend or unable to walk"
					},
					{
						"id": "coordination",
						"title": "Coordination",
						"question": "Coordination",
						"guidance": "Manipulation; ease and fluidity of movement; fine motor skills\nF — Coordinates body parts with each other, uses smooth fluid movements (possibly dextrous)\nA — Some awkwardness or stiffness causing minor interruptions to occupations\nI — Difficulty coordinating movements (clumsy/tremulous/awkward/stiff)\nR — Unable to coordinate, manipulate and use fluid movements"
					},
					{
						"id": "strengthandeffort",
						"title": "Strength and Effort",
						"question": "Strength and Effort",
						"guidance": "Grip; handling; moving, lifting and transporting\nF — Grasps, moves & transports objects securely with adequate force/speed (possibly strong)\nA — Strength and effort are generally sufficient for most tasks\nI — Has difficulty with grasping, moving, transporting objects with adequate force and speed\nR — Unable to grasp, move, transport objects with appropriate force and speed (weak/frail)"
					},
					{
						"id": "energy",
						"title": "Energy",
						"question": "Energy",
						"guidance": "Endurance; pace; attention; stamina\nF — Maintains appropriate energy levels, able to maintain tempo throughout occupation\nA — Energy may be slightly low or high at times, able to pace self for most tasks\nI — Difficulty maintaining energy (tires easily/evidence of fatigue/distractable/restless)\nR — Unable to maintain energy, lacks focus, lethargic, inactive or highly overactive"
					}
				]
			},
			{
				"id": "section6",
				"title": "Environment",
				"items": [
					{
						"id": "physicalspace",
						"title": "Physical Space",
						"question": "Physical Space",
						"guidance": "Facilities; privacy, accessibility, stimulation and comfort\nF — Space affords a range of opportunities, supports & stimulates valued occupations\nA — Space is mostly adequate, allows daily occupations to be pursued\nI — Affords a limited range of opportunities and curtails performance of valued occupations\nR — Space restricts opportunities and prevents performance of valued occupations"
					},
					{
						"id": "physicalresources",
						"title": "Physical Resources",
						"question": "Physical Resources",
						"guidance": "Finance; equipment, tools, possessions and transport\nF — Enable occupational goals to be achieved with ease, equipment and tools are appropriate\nA — Generally allow occupational goals to be achieved, may present some obstacles\nI — Impede ability to achieve occupational goals safely, equipment and tools are inadequate\nR — Have major impact on ability to achieve occupational goals, lack of tools lead to high risks"
					},
					{
						"id": "socialgroups",
						"title": "Social Groups",
						"question": "Social Groups",
						"guidance": "Family; friends; social support; work climate\nF — Social groups offer practical support, values and attitudes support optimal functioning\nA — Generally able to offer support but may be some under or over involvement\nI — Offer reduced support, or detracts from participation, some groups support but not others\nR — Do not support participation due to lack of interest or inappropriate involvement"
					},
					{
						"id": "occupationaldemands",
						"title": "Occupational Demands",
						"question": "Occupational Demands",
						"guidance": "Activity demands; cultural conventions; construction of activities\nF — Demands of activities match well with abilities, interests, energy and time available\nA — Generally consistent with abilities, interest, energy or time available, may present challenges\nI — Some clear inconsistencies with abilities and interest, or energy and time available\nR — Mostly inconsistent with abilities, construction of activity is under or over-demanding"
					}
				]
			}
		],
		"options": [
			{
				"id": "F",
				"title": "F — Facilitates occupational participation",
				"explanation": "Satisfactory participation in context."
			},
			{
				"id": "A",
				"title": "A — Allows occupational participation",
				"explanation": "Minor remaining difficulty or vulnerability."
			},
			{
				"id": "I",
				"title": "I — Inhibits occupational participation",
				"explanation": "Difficulty with major participation impact."
			},
			{
				"id": "R",
				"title": "R — Restricts occupational participation",
				"explanation": "Restricted participation."
			}
		],
		"maxUnrated": 2,
		"dateLabel": "Date of assessment",
		"assessorLabel": "Assessor",
		"environmentLabel": "Treatment setting or assessed environment",
		"analysisLabel": "Analysis of strengths and limitations",
		"commentLabel": "Comments",
		"incompleteLabel": "Incomplete screening",
		"completedLabel": "Completed screening"
	}
}
}


export function createMohostPriorResults() {
	const form = createMohostConfig()
	const answers = {assessmentDate: "2026-08-12", assessor: "Elena Meyer", environment: "Day hospital", analysis: "Communication and task organization supported regular attendance; fatigue remained a barrier."}
	for (const section of form.ordinalProfile.sections) for (const item of section.items) answers[item.id] = "A"
	answers.appraisalofability = "F"
	answers.energy = "I"
	return [{id: "demo-prior-assessment", summary: {form, answers, profileStatus: {complete: true}}}]
}

export function createMohostDemoPayload() {
	const config = createMohostConfig()
	const answers = {assessmentDate: "2026-10-14", assessor: "Elena Meyer", environment: "Day hospital", timingComment: "Not yet assessed", socialgroupsComment: "Not yet assessed", analysis: "Initiative and insight support participation. Daily routines and access to suitable space need closer assessment."}
	for (const section of config.ordinalProfile.sections) for (const item of section.items) answers[item.id] = "A"
	answers.appraisalofability = "F"
	answers.routine = "I"
	answers.physicalspace = "R"
	for (const id of ["timing", "socialgroups", "physicalresources"]) delete answers[id]
	return {form: config, answers}
}
